import { ReactNode } from "react";
import { useSearchParams, Navigate } from "react-router-dom";

type ConditionRouteProps = {
  children: ReactNode;
  condition: boolean;
  redirect?: string;
  loading?: boolean;
  replace?: boolean;
};

export function ConditionalRoute({ children, condition, redirect, loading, replace = true }: ConditionRouteProps) {
  const [searchParams] = useSearchParams();

  if (loading) return "Loading...";
  if (condition) return children;

  const target = redirect ?? searchParams.get("redirectTo") ?? "/";
  const safeTarget = target.startsWith("/") ? target : "/";
  console.log("safeTarget", safeTarget);
  return <Navigate replace={replace} to={safeTarget} />;
}